import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://www.facebook.com/shuvo1549/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
    </div>
    <div>
    <a href="#" target="_self" rel="noopener noreferrer" onclick="event.preventDefault()"><BsTwitter /></a>
    </div>
    <div>
    <a href="#" target="_self" rel="noopener noreferrer" onclick="event.preventDefault()"><BsInstagram /></a>
    </div>
  </div>
);

export default SocialMedia;
